import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useAuth } from '@core/auth/hooks/useAuth';
import { useCart } from '@shared/context/CartContext';
import { ROUTES } from '@shared/constants/routes';
import { NavMenu } from './NavMenu';
import { UserMenu } from './UserMenu';
import { MobileMenu } from './MobileMenu';

export function Header() {
  const { isAuthenticated, isLoading } = useAuth();
  const { itemCount } = useCart();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* Logo */}
          <Link to={ROUTES.HOME} className="flex items-center gap-2 shrink-0">
            <img
              src="/logo.jpeg"
              alt="Reconócete Logo"
              className="h-10 w-10 rounded-lg object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <span className="font-heading text-xl font-bold text-brand-mauve !text-black">
              Reconócete
            </span>
          </Link>

          {/* Right Section */}
          <div className="flex items-center gap-4">
            {/* Cart Icon */}
            <Link
              to={ROUTES.CART}
              className="text-brand-carbon hover:text-brand-mauve transition-colors relative"
              aria-label="Carrito de compras"
            >
              <ShoppingCart className="h-5 w-5" />
              {itemCount > 0 && (
                <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-white">
                  {itemCount > 99 ? '99+' : itemCount}
                </span>
              )}
            </Link>

            {/* Auth Controls - Desktop */}
            <div className="hidden md:flex items-center gap-4">
              {isLoading ? (
                <div className="h-4 w-20 animate-pulse rounded bg-muted" />
              ) : isAuthenticated ? (
                <UserMenu />
              ) : (
                <>
                  <Link
                    to={ROUTES.LOGIN}
                    className="text-sm font-medium text-brand-carbon hover:text-brand-mauve transition-colors"
                  >
                    Ingresar
                  </Link>
                  <Link
                    to={ROUTES.REGISTER}
                    className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-brand-plum transition-colors"
                  >
                    Registrarse
                  </Link>
                </>
              )}
            </div>

            {/* Mobile Menu */}
            <MobileMenu />
          </div>
        </div>

        {/* Navigation Menu - Desktop */}
        <div className="hidden md:block border-t border-border py-2">
          <NavMenu />
        </div>
      </div>
    </header>
  );
}
